import {
   EmergencyNotificationConfiguration,
   EmergencyNotificationConfigurationQuery,
} from '@dreryk/egabinet-emergency-notification-frontend-api';
import { PractitionerView, PractitionerViewQuery } from '@dreryk/egabinet-personnel-frontend-api';

import { useCqrsGet, useCqrsSearch } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { Direction, paginations } from '@dreryk/command-query-ws-client';

import { translationKeys } from '../translations';

type EmergencyNotificationSettingsPanelLoaderRenderProps = {
   emergencyNotificationConfiguration: EmergencyNotificationConfiguration;
   practitioners: PractitionerView[];
};

type EmergencyNotificationSettingsPanelLoaderProps = {
   readonly children: (renderProps: EmergencyNotificationSettingsPanelLoaderRenderProps) => JSX.Element;
};

export const EmergencyNotificationSettingsPanelLoader = (
   props: EmergencyNotificationSettingsPanelLoaderProps
): JSX.Element => {
   const {
      data: emergencyNotificationConfiguration,
      loading: emergencyNotificationConfigurationLoading,
      error: emergencyNotificationConfigurationError,
   } = useCqrsGet<EmergencyNotificationConfiguration>(() => new EmergencyNotificationConfigurationQuery());

   const {
      data: practitioners,
      loading: practitionersLoading,
      error: practitionersError,
   } = useCqrsSearch<PractitionerView>(
      () => new PractitionerViewQuery(),
      paginations.all<PractitionerView>().orderedBy('firstName', Direction.ASCENDING)
   );

   if (emergencyNotificationConfigurationLoading || practitionersLoading) {
      return <LoaderSpinner />;
   }

   if (emergencyNotificationConfigurationError || practitionersError) {
      return (
         <Message
            testId={'fetchError'}
            type={MessageType.NEGATIVE}
            label={translationKeys.fetchDataErrorOccurredDuringEmergencyNotificationConfiguration}
            displayIndicator
         />
      );
   }

   return props.children({
      emergencyNotificationConfiguration: emergencyNotificationConfiguration,
      practitioners: practitioners,
   });
};
